import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/step/:stepTitle',
      name: 'step',
      component: Home,
    },
    {
      path: '/quotes',
      name: 'quotes',
      component: () => import(/* webpackChunkName: "quotes" */ './views/Quotes.vue'),
    },
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "login" */ './views/Login.vue'),
    },
    {
      path: '/forgot-password',
      name: 'forgot-password',
      component: () => import(/* webpackChunkName: "forgot-password" */ './views/ForgotPassword.vue'),
    },
    {
      path: '/reset-password/',
      name: 'reset-password',
      component: () => import(/* webpackChunkName: "reset-password" */ './views/ResetPassword.vue'),
    },
    // {
    //   path: '/admin',
    //   name: 'admin',
    //   component: () => import(/* webpackChunkName: "admin" */ './views/Admin.vue'),
    // },
    {
      path: '/manage',
      name: 'manage',
      component: () => import(/* webpackChunkName: "admin" */ './views/Admin.vue'),
    },
    {
      path: '/profile',
      name: 'profile',
      component: () => import(/* webpackChunkName: "profile" */ './views/Profile.vue'),
    },
    {
      path: '*',
      name: 'not-found',
      component: {
        render(h) {
          return h('main', {
            attrs: { role: 'status' },
            style: { background: '#fff', color: '#222', padding: '2rem' },
          }, [
            h('h1', 'Page not found'),
            h('p', 'The requested page is not available.'),
            h('router-link', { props: { to: '/' } }, 'Return to the artwork'),
          ]);
        },
      },
    },
  ],
});

router.afterEach((to) => {
  // Use the confirmed route, not location.pathname (history may update later).
  // The inline metadata script also handles direct loads before Vue starts.
  if (window.dimonScapePageTitle) {
    window.dimonScapePageTitle.updateRoute(to.path);
  }
});

export default router;
